import React from 'react';
import { QRCodeSVG } from 'qrcode.react';

const LineQRCode = () => {
  // Replace with your actual LINE ID
  const lineId = '@yourlineid';
  const lineUrl = `https://line.me/ti/p/${lineId}`;

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-green-400 via-green-500 to-green-600 p-4">
      <div className="bg-white rounded-3xl shadow-2xl p-8 max-w-md w-full">
        {/* LINE Logo Style Header */}
        <div className="flex items-center justify-center mb-2">
          <div className="bg-green-500 text-white font-bold text-2xl rounded-full w-16 h-16 flex items-center justify-center shadow-lg">
            LINE
          </div>
        </div>

        <h2 className="text-2xl font-bold text-center mb-2 text-gray-800">
          เพิ่มเพื่อน
        </h2>
        <p className="text-center text-gray-500 mb-6 text-sm">
          สแกน QR Code เพื่อเพิ่มเพื่อนใน LINE
        </p>

        {/* QR Code */}
        <div className="flex justify-center mb-6">
          <div className="bg-white p-6 rounded-2xl shadow-xl border-4 border-green-500">
            <QRCodeSVG
              value={lineUrl}
              size={220}
              level="H"
              includeMargin={false}
              fgColor="#00B900"
            />
          </div>
        </div>

        {/* LINE ID */}
        <div className="bg-green-50 rounded-xl p-4 text-center border border-green-200">
          <p className="text-green-700 mb-1 text-sm font-semibold">LINE ID</p>
          <p className="text-2xl font-bold text-green-600">
            {lineId}
          </p>
        </div>

        {/* Info Text */}
        <p className="text-center text-gray-400 text-xs mt-4">
          ใช้แอป LINE สแกน QR Code นี้
        </p>
      </div>
    </div>
  );
};

export default LineQRCode;
